import { render, staticRenderFns } from "./homeBreadcrumb.vue?vue&type=template&id=511a6dce&"
import script from "./homeBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./homeBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/menu/default/homeBreadcrumb.vue"
export default component.exports